import { render, staticRenderFns } from "./MemberMilestones.vue?vue&type=template&id=37e173d8"
import script from "./MemberMilestones.vue?vue&type=script&lang=js"
export * from "./MemberMilestones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports